import axios from 'axios';

class PagarMeV5CardTokenService {
  async create(cardData) {
    const pagarMeV5ApiHost = process.env.PAGARME_V5_API_HOST;
    const publicKey = process.env.PAGARME_V5_PUBLIC_KEY;
    const [expMonth, expYear] = cardData.card_expiration_date.split('/');

    const response = await axios.post(`${pagarMeV5ApiHost}/tokens?appId=${publicKey}`, {
      type: 'card',
      card: {
        number: cardData.card_number.replace(/\s+/g, ''),
        holder_name: cardData.card_holder_name,
        exp_month: expMonth,
        exp_year: expYear,
        cvv: cardData.card_cvv,
      },
    });

    return response?.data?.id;
  }
}

export default new PagarMeV5CardTokenService();
